import { useEffect, useRef, useState } from "react";
import type { EventListTeamInfo, GameClipResponse, MergedGpEventResponse } from "../../../types";
import "./clips.css";
import type { MediaPlayerInstance } from "@vidstack/react";
import { ClipPlayer } from "./ClipPlayer";
import { ClipEvents } from "./ClipEvents";
import { _ } from "i18n";

interface ClipPlayerModalProps {
    mergedEvents: MergedGpEventResponse[];
    clip: GameClipResponse;
    teamInfo: EventListTeamInfo;
    eventCount: number;
}

export function ClipPlayerModal({ eventCount, teamInfo, mergedEvents, clip }: ClipPlayerModalProps) {
    const [currentTime, setCurrentTime] = useState(0);
    const [showSidebar, setShowSidebar] = useState(true);
    const playerRef = useRef<MediaPlayerInstance>(null);
    const containerRef = useRef<HTMLTableCellElement>(null);

    useEffect(() => {
        containerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [])

    return (
        <div ref={containerRef} className="clipPlayerModal-container">
            <div className="clipPlayerModal-player">
                <ClipPlayer
                    eventCount={eventCount}
                    teamInfo={teamInfo}
                    showSidebar={showSidebar}
                    setShowSidebar={setShowSidebar}
                    clip={clip}
                    currentTime={currentTime}
                    mergedEvents={mergedEvents}
                    playerRef={playerRef}
                    setCurrentTime={setCurrentTime}
                />
            </div>
            {(clip.events.length > 0) && <div className="clipPlayerModal-eventList">
                {showSidebar ? <ClipEvents
                    eventCount={eventCount}
                    teamInfo={teamInfo}
                    setShowSidebar={(show: boolean) => setShowSidebar(show)}
                    currentTime={currentTime}
                    mergedEvents={mergedEvents}
                    playerRef={playerRef}
                /> :
                    <div className="showSidebar-container">
                        <div
                            className="menuItem"
                            onClick={() => setShowSidebar(true)}
                        >
                            <div className="item-icon">
                                <span className="icon-new icon-video-list icon-20" />
                            </div>
                            <div className="item-text">{_("gamePage.label.eventList")}</div>
                        </div>
                    </div>
                }
            </div>}
        </div>
    )

}
